export default "__VITE_ASSET__BqZpCtxh__"